<template>
  <div class="runner-order-list">
    <table class="data-table">
      <thead>
        <tr>
          <th>订单号</th>
          <th>服务类型</th>
          <th>下单用户</th>
          <th>订单金额</th>
          <th>跑手服务费</th>
          <th>状态</th>
          <th>接单时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in list" :key="order.id">
          <td>{{ order.order_no }}</td>
          <td>{{ serviceTypeName(order) }}</td>
          <td>
            <div class="order-userinfo">
              <div class="order-community-name">{{ order.community_name || order.shop_name || '-' }}</div>
              <div class="order-user-name">{{ order.user_name || '-' }} {{ order.phone || '' }}</div>
            </div>
          </td>
          <td>{{ (order.pay_amount || 0) / 100 }}</td>
          <td>{{ order.runner_commission != null ? (order.runner_commission / 100) : '-' }}</td>
          <td>
            <span :class="['status-tag', statusClass(order.order_status)]">{{ statusText(order.order_status) }}</span>
          </td>
          <td>{{ formatTime(order.runner_accept_time || order.created_at) }}</td>
          <td>
            <router-link :to="`/orders/detail/${order.id}`" class="btn-view">查看</router-link>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="8" class="empty">暂无进行中订单</td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" v-if="total > 0">
      <button class="page-btn" :disabled="currentPage <= 1" @click="changePage(currentPage - 1)">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button class="page-btn" :disabled="currentPage >= totalPages" @click="changePage(currentPage + 1)">下一页</button>
    </div>
  </div>
</template>

<script>
import { getOrderList } from '@/api/orders'
import { formatDateTime } from '@/utils/date'

// 与后端 running_order_count 口径一致：已接单(2)/已取件(3)/已送达(4) 视为进行中
const IN_PROGRESS_STATUSES = [2, 3, 4]

export default {
  name: 'RunnerOrderList',
  props: {
    runnerId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1
    }
  },
  watch: {
    runnerId: {
      immediate: true,
      handler() {
        this.currentPage = 1
        this.loadOrders()
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / 20) || 1
    }
  },
  methods: {
    async loadOrders() {
      if (!this.runnerId) {
        this.list = []
        this.total = 0
        return
      }
      try {
        const res = await getOrderList({
          page: this.currentPage,
          pageSize: 20,
          runner_id: this.runnerId
        })
        const paginator = res.data || {}
        const all = paginator.data || []
        // 后端仅支持单一 status 过滤，这里按"进行中"口径(2/3/4)二次筛选
        this.list = all.filter(o => IN_PROGRESS_STATUSES.includes(o.order_status))
        this.total = this.list.length
      } catch (e) {
        this.$message && this.$message.error('加载进行中订单失败')
      }
    },
    changePage(page) {
      this.currentPage = page
      this.loadOrders()
    },
    statusText(status) {
      const map = {
        2: '待取件',
        3: '待送达',
        4: '待确认'
      }
      return map[status] || '进行中'
    },
    statusClass(status) {
      const map = {
        2: 'pending',
        3: 'pending',
        4: 'pending'
      }
      return map[status] || 'pending'
    },
    serviceTypeName(order) {
      const map = {
        DELIVERY: '代送物品',
        PURCHASE: '代买物品',
        PICKUP: '代取快递',
        OTHER: '其他',
        ALL: '全部'
      }
      return order.service_type_text || map[order.service_type_code] || '未知'
    },
    formatTime(value) {
      if (!value) return '-'
      return formatDateTime(value)
    }
  }
}
</script>

<style scoped>
.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 6px;
  overflow: hidden;
}
.data-table th,
.data-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  font-size: 13px;
  color: #333;
  white-space: nowrap;
}
.data-table th {
  background: #fafafa;
  font-weight: 600;
}
.data-table tr:hover td {
  background: #f9faff;
}
.empty {
  text-align: center;
  color: #999;
  padding: 24px 0;
}
.order-userinfo {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
}
.order-community-name {
  color: #333;
}
.order-user-name {
  color: #999;
  font-size: 12px;
}
.status-tag {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  background: #eef4ff;
  color: #667eea;
}
.btn-view {
  display: inline-block;
  padding: 5px 14px;
  border: 1px solid #667eea;
  background: #667eea;
  color: #fff;
  border-radius: 4px;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
}
.btn-view:hover {
  background: #5566d6;
  border-color: #5566d6;
}
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 14px;
}
.page-btn {
  padding: 6px 14px;
  border: 1px solid #dcdfe6;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.page-info {
  font-size: 14px;
  color: #666;
}
</style>
